





import { Component, Vue,Prop } from 'vue-property-decorator'
@Component({})
export default class MdcHeadline6 extends Vue{
  @Prop({default:'h1'})
  tag!:string
}
